import React from 'react';
import { Container, Col, Row } from 'reactstrap';


const ShippingToolsAboveBoard = () => (
  <Container>
    <Row>
      <Col md={12}>
        <h5 className="page-title">Tools / Shipping / AboveBoard</h5>
      </Col>
    </Row>
  </Container>
);

export default ShippingToolsAboveBoard;
